import React, { useState } from 'react';
import { Box, Flex, Text, Avatar, Divider, RadioGroup, Radio, Stack, Select, VStack } from '@chakra-ui/react';
import { Home, Settings, LogOut, Download } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useCommitteeContext } from '../context/CommitteeContext';
const TEAL = '#00897B';
const SIDEBAR_BG = '#C8E6C0';
type MenuItemProps = {
  icon: React.ReactNode;
  label: string;
  onClick?: () => void;
};
function MenuItem({
  icon,
  label,
  onClick
}: MenuItemProps) {
  return <Flex align="center" gap={4} px={5} py={3} cursor="pointer" borderRadius="md" _hover={{
    bg: 'rgba(0,137,123,0.12)'
  }} onClick={onClick} role="button" tabIndex={0} onKeyDown={e => e.key === 'Enter' && onClick?.()} data-id="element-88">
      <Box color={TEAL} flexShrink={0} data-id="element-89">
        {icon}
      </Box>
      <Text color={TEAL} fontWeight="500" fontSize="md" data-id="element-90">
        {label}
      </Text>
    </Flex>;
}
export function Sidebar() {
  const [selection, setSelection] = useState<string>('boards');
  const [boardValue, setBoardValue] = useState<string>('');
  const [committeeValue, setCommitteeValue] = useState<string>('');
  const navigate = useNavigate();
  const {
    setSelectedCommittee,
    setSelectedIndex
  } = useCommitteeContext();
  const handleSelectionNavigate = (value: string) => {
    setBoardValue('');
    setCommitteeValue('');
    setSelection(value);
  };
  const handleBoardSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const val = e.target.value;
    setBoardValue(val);
    if (val) navigate('/board');
  };
  const handleCommitteeSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const val = e.target.value;
    setCommitteeValue(val);
    if (val) {
      setSelectedCommittee(val);
      setSelectedIndex(0);
      navigate('/committee');
    }
  };
  return <Box as="nav" bg={SIDEBAR_BG} w="290px" minW="290px" position="fixed" top="64px" left={0} bottom={0} zIndex={90} display="flex" flexDirection="column" overflowY="auto" data-id="element-91">
      {/* User Box */}
      <Flex align="center" gap={3} px={4} py={4} borderBottom="1px solid rgba(0,137,123,0.25)" data-id="element-92">
        <Avatar name="Keith Price" bg="#7B1FA2" color="white" size="md" fontWeight="bold" getInitials={() => 'KP'} data-id="element-93" />

        <Box data-id="element-94">
          <Text fontWeight="bold" color={TEAL} fontSize="md" lineHeight="1.2" data-id="element-95">
            Keith Price
          </Text>
          <Text color={TEAL} fontSize="sm" opacity={0.85} data-id="element-96">
            zMagic Solutions
          </Text>
        </Box>
      </Flex>

      {/* Menu Items */}
      <VStack align="stretch" spacing={0} flex={1} pt={2} data-id="element-97">
        {/* Home */}
        <MenuItem icon={<Home size={26} strokeWidth={1.8} data-id="element-99" />} label="Home" onClick={() => navigate('/welcome')} data-id="element-98" />

        {/* Boards / Committees Radio Group + Dropdown */}
        <Box px={5} pt={3} pb={2} data-id="element-100">
          <RadioGroup value={selection} onChange={handleSelectionNavigate} colorScheme="teal" data-id="element-101">
            <Stack direction="column" spacing={2} data-id="element-102">
              <Radio value="boards" size="md" data-id="element-103">
                <Text color={TEAL} fontWeight="500" fontSize="md" data-id="element-104">
                  Boards
                </Text>
              </Radio>
              <Radio value="committees" size="md" data-id="element-105">
                <Text color={TEAL} fontWeight="500" fontSize="md" data-id="element-106">
                  Committees
                </Text>
              </Radio>
            </Stack>
          </RadioGroup>

          {/* Dropdown */}
          <Box mt={3} data-id="element-107">
            {selection === 'boards' ? <Select placeholder="Select Board" value={boardValue} onChange={handleBoardSelect} size="sm" borderColor={TEAL} focusBorderColor={TEAL} color={TEAL} _placeholder={{
            color: TEAL
          }} sx={{
            '> option': {
              color: '#333'
            }
          }} data-id="element-108">
                <option value="WPGA_WA" data-id="element-109">WPGA - WA</option>
              </Select> : <Select placeholder="Select Committee" value={committeeValue} onChange={handleCommitteeSelect} size="sm" borderColor={TEAL} focusBorderColor={TEAL} color={TEAL} _placeholder={{
            color: TEAL
          }} sx={{
            '> option': {
              color: '#333'
            }
          }} data-id="element-110">
                <option value="international_marketing" data-id="element-111">
                  International Marketing
                </option>
                <option value="domestic_marketing" data-id="element-112">Domestic Marketing</option>
                <option value="research" data-id="element-113">Research</option>
                <option value="information_government_education" data-id="element-114">
                  Information/Government Education
                </option>
              </Select>}
          </Box>
        </Box>

        {/* Divider */}
        <Box px={4} py={3} data-id="element-115">
          <Divider borderColor="rgba(0,137,123,0.4)" data-id="element-116" />
        </Box>

        {/* Download */}
        <MenuItem icon={<Download size={26} strokeWidth={1.8} data-id="element-118" />} label="Download" data-id="element-117" />

        {/* Account */}
        <MenuItem icon={<Settings size={26} strokeWidth={1.8} data-id="element-120" />} label="Account" onClick={() => navigate('/account')} data-id="element-119" />

        {/* Log Out */}
        <MenuItem icon={<LogOut size={26} strokeWidth={1.8} data-id="element-122" />} label="Log Out" onClick={() => navigate('/login')} data-id="element-121" />
      </VStack>
    </Box>;
}